import { render } from "./MoreBlogsView.vue?vue&type=template&id=65c65fac"
import script from "./MoreBlogsView.vue?vue&type=script&lang=js"
export * from "./MoreBlogsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__